import request from '@/utils/request'

export function getcategoryList(params) { // 分类列表
    return request({
        url: '/backend/business-school/category/list',
        method: 'get',
        params: params
    });
}
export function createUpdate(data) { // 创建或者修改分类信息
    return request({
        url: '/backend/business-school/category/createUpdate',
        method: 'post',
        data: data
    })
}
export function delcategory(data) { // 创建或者修改分类信息
    return request({
        url: '/backend/business-school/category/del',
        method: 'post',
        data: data
    })
}

export function coursecreateUpdate(data) { // 创建或者修改课程信息
    return request({
        url: '/backend/business-school/course/createUpdate',
        method: 'post',
        data: data
    })
}

export function courselist(data) { // 课程列表
    return request({
        url: '/backend/business-school/course/list',
        method: 'post',
        data: data
    })
}

export function courseinfo(data) { // 
    return request({
        url: '/backend/business-school/course/info',
        method: 'post',
        data: data
    })
}

export function coursedel(data) { // 课程删除
    return request({
        url: '/backend/business-school/course/del',
        method: 'post',
        data: data
    })
}

export function coursesttusupdate(data) { 
    return request({
        url: '/backend/business-school/course/status/update',
        method: 'post',
        data: data
    })
}
export function articlesttusupdate(data) { 
    return request({
        url: '/backend/business-school/course/createUpdate/article',
        method: 'post',
        data: data
    })
}
//修改课程推荐状态
export function courseRecommendUpdate(data) {
    return request({
        url: '/backend/business-school/course/recommend-status/update',
        method: 'post',
        data: data
    })
}